/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Campaign,
  CreateCall201Response,
  CreatePrivateCampaignDto,
  DeleteCallsByIds200Response,
  DeleteCallsByIdsRequest,
  UpdateCallComment200Response,
  UpdateCampaignDto,
} from '../models/index';
import {
    CampaignFromJSON,
    CampaignToJSON,
    CreateCall201ResponseFromJSON,
    CreateCall201ResponseToJSON,
    CreatePrivateCampaignDtoFromJSON,
    CreatePrivateCampaignDtoToJSON,
    DeleteCallsByIds200ResponseFromJSON,
    DeleteCallsByIds200ResponseToJSON,
    DeleteCallsByIdsRequestFromJSON,
    DeleteCallsByIdsRequestToJSON,
    UpdateCallComment200ResponseFromJSON,
    UpdateCallComment200ResponseToJSON,
    UpdateCampaignDtoFromJSON,
    UpdateCampaignDtoToJSON,
} from '../models/index';

export interface AddParticipantsRequest {
    campaignId: number;
    requestBody: Array<string>;
}

export interface CreateCampaignRequest {
    createPrivateCampaignDto: CreatePrivateCampaignDto;
}

export interface CreateCampaignFromFileRequest {
    file?: Blob;
    createCampaignDto?: string;
    participantIds?: string;
}

export interface DeleteCallsByIdsOperationRequest {
    deleteCallsByIdsRequest: DeleteCallsByIdsRequest;
}

export interface DeleteCampaignByIdRequest {
    campaignId: number;
}

export interface RemoveParticipantsRequest {
    campaignId: number;
    requestBody: Array<string>;
}

export interface UpdateCampaignRequest {
    campaignId: number;
    updateCampaignDto: UpdateCampaignDto;
}

/**
 * 
 */
export class CampaignApi extends runtime.BaseAPI {

    /**
     * Add participants to a campaign
     */
    async addParticipantsRaw(requestParameters: AddParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateCallComment200Response>> {
        if (requestParameters['campaignId'] == null) {
            throw new runtime.RequiredError(
                'campaignId',
                'Required parameter "campaignId" was null or undefined when calling addParticipants().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling addParticipants().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/campaign/{campaignId}/participants/add`;
        urlPath = urlPath.replace(`{${"campaignId"}}`, encodeURIComponent(String(requestParameters['campaignId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateCallComment200ResponseFromJSON(jsonValue));
    }

    /**
     * Add participants to a campaign
     */
    async addParticipants(requestParameters: AddParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateCallComment200Response> {
        const response = await this.addParticipantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new campaign
     */
    async createCampaignRaw(requestParameters: CreateCampaignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCall201Response>> {
        if (requestParameters['createPrivateCampaignDto'] == null) {
            throw new runtime.RequiredError(
                'createPrivateCampaignDto',
                'Required parameter "createPrivateCampaignDto" was null or undefined when calling createCampaign().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/campaign`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePrivateCampaignDtoToJSON(requestParameters['createPrivateCampaignDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCall201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a new campaign
     */
    async createCampaign(requestParameters: CreateCampaignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCall201Response> {
        const response = await this.createCampaignRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Créer une campagne à partir d\'un fichier SIRETs
     */
    async createCampaignFromFileRaw(requestParameters: CreateCampaignFromFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Campaign>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        if (requestParameters['createCampaignDto'] != null) {
            formParams.append('createCampaignDto', requestParameters['createCampaignDto'] as any);
        }

        if (requestParameters['participantIds'] != null) {
            formParams.append('participantIds', requestParameters['participantIds'] as any);
        }


        let urlPath = `/campaign/sirets/create-from-file`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CampaignFromJSON));
    }

    /**
     * Créer une campagne à partir d\'un fichier SIRETs
     */
    async createCampaignFromFile(requestParameters: CreateCampaignFromFileRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Campaign>> {
        const response = await this.createCampaignFromFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete multiple call by their IDs
     */
    async deleteCallsByIdsRaw(requestParameters: DeleteCallsByIdsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteCallsByIds200Response>> {
        if (requestParameters['deleteCallsByIdsRequest'] == null) {
            throw new runtime.RequiredError(
                'deleteCallsByIdsRequest',
                'Required parameter "deleteCallsByIdsRequest" was null or undefined when calling deleteCallsByIds().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/campaign/delete`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteCallsByIdsRequestToJSON(requestParameters['deleteCallsByIdsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteCallsByIds200ResponseFromJSON(jsonValue));
    }

    /**
     * Delete multiple call by their IDs
     */
    async deleteCallsByIds(requestParameters: DeleteCallsByIdsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteCallsByIds200Response> {
        const response = await this.deleteCallsByIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a campaign
     */
    async deleteCampaignByIdRaw(requestParameters: DeleteCampaignByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['campaignId'] == null) {
            throw new runtime.RequiredError(
                'campaignId',
                'Required parameter "campaignId" was null or undefined when calling deleteCampaignById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/campaign/{campaignId}`;
        urlPath = urlPath.replace(`{${"campaignId"}}`, encodeURIComponent(String(requestParameters['campaignId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a campaign
     */
    async deleteCampaignById(requestParameters: DeleteCampaignByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCampaignByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Get manager campaigns by user id
     */
    async getManagerCampaignsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Campaign>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/campaign/manager`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CampaignFromJSON));
    }

    /**
     * Get manager campaigns by user id
     */
    async getManagerCampaigns(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Campaign>> {
        const response = await this.getManagerCampaignsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get manager campaigns user is in
     */
    async getMyManagerCampaignsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Campaign>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/campaign/manager/salesforce`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CampaignFromJSON));
    }

    /**
     * Get manager campaigns user is in
     */
    async getMyManagerCampaigns(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Campaign>> {
        const response = await this.getMyManagerCampaignsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get private campaigns by user id
     */
    async getPrivateCampaignsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Campaign>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/campaign/private`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CampaignFromJSON));
    }

    /**
     * Get private campaigns by user id
     */
    async getPrivateCampaigns(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Campaign>> {
        const response = await this.getPrivateCampaignsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Remove participants from a campaign
     */
    async removeParticipantsRaw(requestParameters: RemoveParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateCallComment200Response>> {
        if (requestParameters['campaignId'] == null) {
            throw new runtime.RequiredError(
                'campaignId',
                'Required parameter "campaignId" was null or undefined when calling removeParticipants().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling removeParticipants().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/campaign/{campaignId}/participants/remove`;
        urlPath = urlPath.replace(`{${"campaignId"}}`, encodeURIComponent(String(requestParameters['campaignId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateCallComment200ResponseFromJSON(jsonValue));
    }

    /**
     * Remove participants from a campaign
     */
    async removeParticipants(requestParameters: RemoveParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateCallComment200Response> {
        const response = await this.removeParticipantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a campaign
     */
    async updateCampaignRaw(requestParameters: UpdateCampaignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateCallComment200Response>> {
        if (requestParameters['campaignId'] == null) {
            throw new runtime.RequiredError(
                'campaignId',
                'Required parameter "campaignId" was null or undefined when calling updateCampaign().'
            );
        }

        if (requestParameters['updateCampaignDto'] == null) {
            throw new runtime.RequiredError(
                'updateCampaignDto',
                'Required parameter "updateCampaignDto" was null or undefined when calling updateCampaign().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/campaign/{campaignId}`;
        urlPath = urlPath.replace(`{${"campaignId"}}`, encodeURIComponent(String(requestParameters['campaignId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCampaignDtoToJSON(requestParameters['updateCampaignDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateCallComment200ResponseFromJSON(jsonValue));
    }

    /**
     * Update a campaign
     */
    async updateCampaign(requestParameters: UpdateCampaignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateCallComment200Response> {
        const response = await this.updateCampaignRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
